import { ShopifyVariantMetaField } from './queryVariantsByProductId'

export const getInventoryType = (shopifyVariantMetaField: ShopifyVariantMetaField) => {
  return shopifyVariantMetaField.inventoryType?.value || shopifyVariantMetaField.inventoryTypeLowerCase?.value
}

export const getPreOrderShippingDate = (shopifyVariantMetaField: ShopifyVariantMetaField) => {
  return (
    shopifyVariantMetaField.preOrderShippingDate?.value || shopifyVariantMetaField.preOrderShippingDateLowerCase?.value
  )
}
